import React from 'react';

const Nose = ({ coordinates, size, color }) => {
  const { x, y } = coordinates;

  return (
    <g
      transform={`translate(${x} ${y}) scale(${size})`}
    >
      <path 
        d="M59.7413 42.6245C54.5455 47.7137 46.1777 47.7137 40.9818 42.6245L20.8678 22.9234C12.4012 14.6306 18.3352 0.34937 30.2475 0.349369L70.4756 0.349365C82.388 0.349364 88.322 14.6306 79.8553 22.9234L59.7413 42.6245Z" 
        fill={color}
      />
      <path 
        d="M0.359589 88.7552C30.3914 88.4043 54.6699 64.3778 55.0245 34.6576H45.69C45.3366 59.2763 25.2365 79.1678 0.359589 79.5175L0.359589 88.7552Z" 
        fill={color}
      />
      <path 
        d="M100.36 88.7552C70.3277 88.4043 46.0493 64.3778 45.6947 34.6576H55.0292C55.3826 59.2763 75.4827 79.1678 100.36 79.5175V88.7552Z" 
        fill={color}
      />
    </g>
  );
}

export default Nose;
